export const AMOUNT_PRESETS = [100000, 500000, 1000000, 2000000, 4000000];

export const PURPOSE_OPTIONS = [
  "Reserva",
  "Viagem",
  "Casa",
  "Reforma",
  "Carro",
  "Negócio",
  "Estudos",
  "Pagamento",
  "Compra",
  "Outro",
  "Prefiro não informar",
];

export const formatCurrency = (cents) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format((Number(cents) || 0) / 100);

export const progressPercentage = (goal) => {
  if (goal.is_complete) return 100;
  if (!goal.amount_cents) return 0;
  return Math.floor((goal.saved_cents / goal.amount_cents) * 100);
};

export const parseCurrencyToCents = (value) => {
  const compact = String(value || "").replace(/[^\d,.-]/g, "").trim();
  if (!compact) return 0;
  const comma = compact.lastIndexOf(",");
  const dot = compact.lastIndexOf(".");
  const separator = Math.max(comma, dot);
  const whole = separator === -1 ? compact : compact.slice(0, separator);
  const decimal = separator === -1 ? "" : compact.slice(separator + 1);
  const normalized = `${whole.replace(/\D/g, "")}.${decimal.replace(/\D/g, "")}`;
  return Math.round(Number(normalized) * 100) || 0;
};

export const deadlineLabel = (goal) => {
  if (goal.deadline_mode === "date" && goal.deadline_date) {
    return new Date(`${goal.deadline_date}T12:00:00`).toLocaleDateString("pt-BR");
  }
  if (goal.deadline_mode === "days" && goal.deadline_days) {
    return `${goal.deadline_days} dia${goal.deadline_days === 1 ? "" : "s"}`;
  }
  return "Sem prazo definido";
};

export const todayForDateInput = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};